// extracted by mini-css-extract-plugin
export default {"loginContent":"AuthBySms_loginContent__3C6Cs","loginForm":"AuthBySms_loginForm__ebuKf"};